import apiClient from "@/api/client";

export default {
  fetchNetworks() {
    return apiClient.get("/networks");
  },
};
